import {
  mappedSpacingScaleKeys
} from "./chunk-WA5F6AED.mjs";

// src/utils/tv.ts
import { createTV } from "tailwind-variants";
var COMMON_UNITS = ["small", "medium", "large"];
var tv = createTV({
  twMerge: true,
  twMergeConfig: {
    theme: {
      opacity: ["disabled"],
      spacing: ["divider", "unit", ...mappedSpacingScaleKeys],
      borderWidth: COMMON_UNITS,
      borderRadius: COMMON_UNITS
    },
    classGroups: {
      shadow: [{ shadow: COMMON_UNITS }],
      "font-size": [{ text: ["tiny", ...COMMON_UNITS] }],
      "bg-image": ["bg-stripe-gradient"],
      "min-w": [
        {
          "min-w": ["unit", ...mappedSpacingScaleKeys]
        }
      ],
      "min-h": [
        {
          "min-h": ["unit", ...mappedSpacingScaleKeys]
        }
      ]
    }
  }
});

export {
  tv
};
